import { useState, useEffect } from 'react'
import _ from 'lodash';

import { Spinner } from 'react-bootstrap';
import { ScreenSides } from '../../../../SharedComponents/RSS/Positions/ScreenSides';
import { Bar } from '../../../../SharedComponents/RSS/Positions/Bar';
import { TEMPLATE_FEED } from '../../../../../Constants/apps';
import { useReadRss } from '../../../../../queries';
import { setRssSettings } from '../../../../../redux/Slices/Apps/appsSlice';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function RssPreview({ rssURL = "", rssSettings, isCustomRSS = false, isCreation = false }) {
    const { t } = useTranslation();
    const readRss = useReadRss();
    const dispatch = useDispatch()
    const location = useLocation()
    const [feeds, setFeeds] = useState([]);
    const [activePosition, setActivePosition] = useState();
    const isCampaignPreview = location.pathname.startsWith('/campaigns');

    const readHandler = async (rssURL) => {
        await readRss.mutateAsync({ url: rssURL }, {
            onSuccess: (data) => {
                setFeeds(data?.posts)
            }
        })
    }

    useEffect(() => {
        dispatch(setRssSettings(rssSettings))
    }, []);


    // useEffect to trigger an action when the url input changes
    useEffect(() => {
        const _url = rssURL;
        setFeeds([])
        if (!_.isEmpty(_url) && process.env.REACT_APP_APP_ENV !== "local") {
            readHandler(_url)
        }
    }, [rssURL]);

    useEffect(() => {
        if (isCustomRSS && isCreation)
            setFeeds(TEMPLATE_FEED?.[rssSettings?.language])
    }, [rssSettings?.language]);


    useEffect(() => {
        let _position = rssSettings?.position;
        let _child = {}
        switch (_position) {
            case "FULL_SCREEN":
                _child = ({
                    component: <ScreenSides feeds={feeds} />,
                    classes: "justify-content-center align-items-center",
                })
                break;
            case "BOTTOM":
                _child = {
                    component: <Bar feeds={feeds} preview={isCampaignPreview ? false : true} />,
                    classes: "justify-content-center align-items-end",
                }
                break; case "TOP":
                _child = {
                    component: <Bar feeds={feeds} preview={isCampaignPreview ? false : true} />,
                    classes: "justify-content-center align-items-start",
                }
                break;
            default:
                _child = {
                    component: <></>,
                    classes: "justify-content-center align-items-center"
                }
                break;
        }

        setActivePosition(_child)
    }, [rssSettings.position, feeds]);

    return (
        <div className={`d-flex h-full w-full border-5 border-dark h-100 ${readRss.isLoading ? "justify-content-center align-items-center" : activePosition?.classes}`}>
            {
                readRss.isLoading ?
                    <Spinner as="span" variant="primary" size='lg' animation="border" role="status" className='mx-3 my-5 ' aria-hidden="true" />
                    :
                    process.env.REACT_APP_APP_ENV == "local" && !isCreation ?
                        <div className='d-flex justify-content-center flex-column align-items-center my-auto'>
                            <i className="fas fa-cogs fs-1 mb-3"></i>
                            <p className='text-center'>{t("devices.preview_rss_device_preview")}</p>
                        </div>
                        :
                        feeds?.length > 0
                            ? activePosition?.component
                            :
                            <div className='d-flex justify-content-center flex-column align-items-center my-auto'>
                                <i className="fas fa-cogs fs-1 mb-3"></i>
                                <h5 className='text-center mb-2'>{t("devices.preview_rss_app_instance_title")}</h5>
                                <p className='text-center'>{t("devices.preview_rss_app_instance_hint")}</p>
                            </div>
            }
        </div >
    )
}

export default RssPreview